import * as allBrandConfigs from './config';

export * from './getBrandConfig';

export const brandConfigs = allBrandConfigs;
